import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMissingData } from '../../hooks/useMissingData';
import Progress from '../Progress/Progress';
import { t } from '../../i18n/i18n';
import emptyUserPhoto from '../../assets/header/profile.svg';
import './HomeUserProfile.scss';

const HomeUserProfile = ({ workspacePage }) => {
  const history = useHistory();
  const percentage = useMissingData();
  const { user } = useSelector((state) => state.auth);

  const determineImageClassname = () => (workspacePage ? 'size-profile-img' : 'home-profile-img');

  return (
    <div
      data-testid="home-profile"
      className={`home-profile d-flex align-items-stretch ${
        workspacePage ? 'px-4 w-100 b-radius-8 bg-white' : 'w-100 px-4'
      }`}
    >
      <div
        className={`d-flex flex-row ${
          workspacePage ? 'px-2 w-100 workspace-profile-content' : 'gap-2 w-100'
        }`}
      >
        <div className="d-flex align-items-center">
          <img
            data-testid="profile-img"
            className={determineImageClassname()}
            src={user?.picture ? user?.picture : emptyUserPhoto}
            alt={t('PROFILE_PICTURE_OF_PROFILE')}
          />
        </div>
        <div
          className={`d-flex w-100 ${
            workspacePage
              ? 'flex-row  align-items-center justify-content-between'
              : 'justify-content-between flex-column w-100'
          }`}
          style={{ minHeight: '100%' }}
        >
          <span
            className={`font-weight-700  text-title ${
              workspacePage ? 'position-profile-name' : ''
            }`}
          >
            <span>{`${user.firstName} ${user.lastName}`}</span>
          </span>
          <div
            className={`d-flex gap-1 mt-auto ${
              workspacePage
                ? 'button-create-workspace w-50 align-items-center justify-self-end'
                : 'w-100 flex-column'
            }`}
          >
            <div className={`${workspacePage ? 'position-progress-bar w-100' : 'w-100'}`}>
              <span className="completed-percentage-text font-weight-600 text-xs">
                {percentage < 100
                  ? `${t('YOUR_PROFILE_IS_AT_PERCENT')} ${percentage}%`
                  : t('HOME_YOUR_PROFILE_IS_COMPLETED')}
              </span>
              <Progress percent={percentage} className="home-progress" isCredits={false} />
            </div>
            <div
              className={`d-flex ${
                workspacePage ? 'w-50' : 'flex-column flex-lg-row gap-1 home-profile-content w-100'
              } justify-content-end`}
            >
              <button
                type="button"
                data-testid="redirect-profile-button"
                onClick={() => history.push('/profile')}
                className={`font-weight-700 text-xs font-bold complete-profile-button-tertiary ${
                  workspacePage ? '' : 'home-profile-button'
                }`}
              >
                {percentage !== 100 ? t('HOME_COMPLETE_YOUR_PROFILE') : t('HOME_EDIT_YOUR_PROFILE')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeUserProfile;
